import { render, staticRenderFns } from "./BTableMunMehExpertForms.vue?vue&type=template&id=46f5bb04&"
import script from "./BTableMunMehExpertForms.vue?vue&type=script&lang=js&"
export * from "./BTableMunMehExpertForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports